var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-layout"},[_c('Navbar'),_c('main',{staticClass:"content"},[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }